import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SurveyViewModel } from 'src/app/common/viewmodel/survey-view-model';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';
import { DeleteSurveyConfirmationModalComponent } from '../delete-survey-confirmation-modal/delete-survey-confirmation-modal.component';

@Component({
  selector: 'app-delete-survey-modal',
  templateUrl: './delete-survey-modal.component.html',
  styleUrls: ['./delete-survey-modal.component.scss']
})
export class DeleteSurveyModalComponent implements OnInit {
  @Input() public tenantName;
  @Input() public surveyKeys;
  isDeleting: boolean = false;
  isButtonDisabled: boolean = false;
  surveyKeyIds = new Array();
  deleteError: boolean;
  
  constructor(public tenantService: TenantService, private route: ActivatedRoute, private modalService: NgbModal, private activeModal: NgbActiveModal) { }
  modalOption: NgbModalOptions = {
    backdrop: 'static',
    backdropClass: 'backdrop-confirmation',
    keyboard: false
  };
  
  ngOnInit(){
    if (this.surveyKeys.length == 0) {
      this.isButtonDisabled = true;
    }
  }
  
  onCloseModal() {
    this.activeModal.close();
  }

  deleteConfirmation() {
    this.isButtonDisabled = true;
    this.isDeleting = true;

    this.surveyKeys.forEach(e => {
      this.surveyKeyIds.push(e.surveyKey);
    });
    let deleteSurveyKeys = new SurveyViewModel();
    deleteSurveyKeys.tenantName = this.tenantName;
    deleteSurveyKeys.surveyKeys = this.surveyKeyIds;

    this.tenantService.deleteSurveys(deleteSurveyKeys).subscribe(_ => {  
      this.activeModal.close();       
    }, (error: any) => {
      this.deleteError = true;
    });
  }
}
